import jwt_decode from 'jwt-decode';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- JWT decode returns untyped payload
export function getDecodedToken(token: string | null): Record<string, unknown> | null {
  try {
    if (!token) {
      return null;
    }

    return jwt_decode(token) as Record<string, unknown>;
  } catch {
    return null;
  }
}
